export default "__VITE_ASSET__b8c0f459__"